





















































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { CardForm } from '@/components/bwaff';
import Form, { Send } from '@/components/form-base';
import { GeneralApi } from '../api';
import dialogTargetMock from '@/components/dialogs/dialog-target-mock';

@Component({
  components: {
    CardForm
  }
})
export default class Redirect extends Form {
  @Prop() 
  api: GeneralApi;

  @Prop() 
  data: any;

  trafficErrorReturnUrl: string = '';
  stopArchivedCampaigns: boolean = false;
  edit: boolean = false;
  form: any = this.defaultForm;
  dialogTargetMock = dialogTargetMock();

  get defaultForm(): any {
    return this.getUserData(this.$store.state.user);
  }

  getUserData(user: any) {
    return {
      trafficErrorReturnUrl: user.trafficErrorReturnUrl,
      allowBotUserAgents: user.allowBotUserAgents,
      allowSuspiciousReferrer: user.allowSuspiciousReferrer,
      userAgentClientHintsEnabled: user.userAgentClientHintsEnabled || false,
      trackConversionsNoClickId: user.trackConversionsNoClickId || false,
      stopArchivedCampaigns: user.stopArchivedCampaigns === 1 
        ? true 
        : user.stopArchivedCampaigns 
    };
  }

  @Watch('defaultForm')
  dataReceived(val: any) {
    this.form = val;
  }

  setEdit(value: boolean) {
    this.edit = value;

    if(!value) {
      this.form = this.getUserData(this.$store.state.user);
      this.state = {};
    }
  }

  @Send(true)
  submit() {
    return this.api.put(this.form).then((res: any) => {
      this.$store.commit('updateUser', res);
      this.edit = false;

      this.bus.emit(
        'toast-success', 
        this.t('Changes have been successfully saved')
      );
    });
  }
}
